import { paySystem,getAppClient } from './commonUtils.js'
import { store } from '@/observable/store'
// 必传  投保人对象 applicant 保险类型 template 实付金额 amount 应付金额 payable_amount

export const Parameter = ({modify,pay_period,applicant,insure,template,tmpl,pay_action,amount,payable_amount,from_salesman,...res})=>{
  const insureArray = insure ? insure[0] : {}
  console.log('insureArray',insureArray)

  let edition;
  if(getAppClient() == 'APP'){
      edition=20
  }else{
      edition=10
  }
  let parmer = { 
      modify:modify ? modify:'',
      pay_period:pay_period ? pay_period : 'year', // 年缴 year 月交 month
      source:1, //来源id
      edition,
      applicant:{  //投保人对象
          phone:applicant.phone,//手机号
          name:applicant.name,//姓名
          idcard:applicant.idcard//身份证号码
      },
      insure:[
          { //被保人对象
              phone:applicant.phone,//手机号 
              name:insureArray.name ? insureArray.name : applicant.name,//姓名
              idcard: insureArray.idcard ? insureArray.idcard : applicant.idcard,//身份证号码
              coverage:insureArray.coverage ? insureArray.coverage : 600000000,//保额
              relation:insureArray.relation ? insureArray.relation : "self", //被保人
              social_security:insureArray.social_security ? insureArray.social_security : 0, //0-无社保, 1-有社保
              amount:parseInt(((insureArray.amount ? insureArray.amount : amount) * 100).toFixed()), //实付金额
              payable_amount:(insureArray.payable_amount ? insureArray.payable_amount : payable_amount) * 100,//应付金额
              extra_enums:insureArray.extra_enums ? insureArray.extra_enums : 0, //0-无操作, 1-智齿拔除意外 , 5-月付
          }
      ],
      // user_id:this.uid,
      user_id:1155,
      template:template || tmpl, // 保险类型
      tmpl:template || tmpl, // 保险类型
      pay_action:pay_action ? pay_action : "paid", //支付方式(paid-支付, entrust-签约代扣)
      trade_type:getAppClient(),//起调支付方式(JSAPI-公众号, MWEB-H5浏览器,APP-app)
      system:paySystem(),
      pay_type:'0',
      version:0,
      amount:parseInt((amount * 100).toFixed()), //实付金额
      payable_amount:parseInt((payable_amount * 100).toFixed()),//应付金额 
      from_action: store.refid.item_id || '',
      from_salesman: from_salesman || '',
      agent_user_id: parseInt(store.refid.zt_item_id) || 0, //分销人员id
      ...res
  }
  return parmer
}
// 增加tmpl也代表保险类型  用于兼容两种支付 统一参数去核保 
    // template:template || tmpl, // 保险类型
    // tmpl:template || tmpl, // 保险类型